import {loadStripe} from '@stripe/stripe-js';
import {Elements} from '@stripe/react-stripe-js';
import { PaymentForm } from './PaymentForm';
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export const Payment = ({ userType = "company" }: { userType?: "company" | "cleaner" }) => {
    const options = {
      appearance: {/*...*/},
    };
  
  return (
    <Elements stripe={stripePromise} options={options}>
      <PaymentForm userType={userType} />
    </Elements> 
  );
};
